module.exports = __webpack_public_path__ + "static/media/about img3.68ab73c7.png";